export default {
	"title": "ต้องการความช่วยเหลือ",
	"image": "ภาพหน้าจอ",
	"email": "Email",
	"name": "ชื่อ",
	"placeholder": "คุณสามารถอธิบายปัญหาของคุณหรือแบ่งปันความคิดของคุณกับเราที่นี่",
	"desc": "ความคิดเห็นของคุณจะได้รับการจัดการโดยเร็วที่สุด",
	"submit": "ส่ง",
}
